import React, { useEffect } from "react";
import HomeBanner from "../components/HomeBanner";
import Features from "../components/Features";
import Mission from "../components/Mission_Vission";
import HomeEvents from "../components/HomeEvents";
import SpecialCare from "../components/Home_Solution";
import Services from "../components/Services";
import Craft from "../components/Craft";
import Pricing from "../components/Pricing";
import GlobalAudienceSection from "../components/Globalaudience";
import LogoSlider from "../components/LogoSlider";
import MentorSlide from "../components/MentorSlide";
import VideoSection from "../components/VideoSection";
import { Helmet } from "react-helmet";
import StartUpIdeas from "../components/StartUpIdeas";
import ExclusiveEvents from "../components/ExclusiveEvents";
import InvestmentReadlines from "../components/InvestmentReadlines";
import StudentAmbassoderProgram from "../components/StudentAmbassoderProgram";
import ResidencyProgram from "../components/ResidencyProgram";
import BussinessProgram from "../components/BussinessProgram";
// import PhotoGallery from "../components/PhotoGallery";

export default function Home() {

  return (
    <div>
      <Helmet>
        <title>TACTOS - The Startup Valley</title>
        <meta
          name="description"
          content="TACTOS is where ambitious founders grow faster. We connect startups with investors, deliver hands-on mentoring, offer real-world startup education, and host exclusive networking & knowledge gaining events - all designed to turn bold ideas into powerful businesses."
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Tactos - The Startup Valley" />
        <meta
          property="og:description"
          content="TACTOS is where ambitious founders grow faster. We connect startups with investors, deliver hands-on mentoring, offer real-world startup education, and host exclusive networking & knowledge gaining events - all designed to turn bold ideas into powerful businesses."
        />
        <meta property="og:url" content="https://tactos.in/" />
        <meta property="og:type" content="website" />

        {/* ✅ Add this canonical tag */}
        <link rel="canonical" href="https://tactos.in/" />
      </Helmet>


      <HomeBanner />
      <Features />
      <Mission />
      <HomeEvents />
      {/* <ExclusiveEvents /> */}
      <MentorSlide />
      {/* <SpecialCare /> */}
      <InvestmentReadlines />
      <StudentAmbassoderProgram />
      <ResidencyProgram />
      <BussinessProgram />
      <StartUpIdeas />

      <VideoSection />
      {/* <PhotoGallery /> */}
      <LogoSlider />

      <Services />
      {/* <Craft /> */}
      {/* <Pricing /> */}
      {/* <GlobalAudienceSection /> */}
    </div>
  );
}
